<template>
  <div style="padding: 20px; min-height: 630px; background-color: rgba(221, 225, 230, 1); border: solid 1px #ccc">
    <div class="row">
      <div class="col-md-12">
        <span class="title_bi mr-4">Ingresos vs Egresos</span>
        <input name="desde" type="date" v-model="from_date" class="mt-1" style="font-size: 14px; cursor: pointer" title="Desde" @change="getIngresosVsEgresos" />
        -
        <input name="hasta" type="date" v-model="to_date" class="mt-1" style="font-size: 14px; cursor: pointer" title="Hasta" @change="getIngresosVsEgresos" />
      </div>
    </div>
    <div class="row">
      <div class="col-md-8">
        <v-card style="min-height: 350px">
          <v-card-title> </v-card-title>
          <div class="col-md-12">
            <v-chip outlined color="#388E3C"> Ingresos: {{ currency.name }} {{ new Intl.NumberFormat("es-ES").format(total_ingresos) }} </v-chip>
            <v-chip outlined class="ml-2" color="#E53935"> Egresos: {{ currency.name }} {{ new Intl.NumberFormat("es-ES").format(total_egresos) }} </v-chip>
          </div>

          <apexchart type="area" height="250" ref="statIngresosEgresos" :options="chartOptionsIngresosEgresos" :series="seriesIngresosEgresos"></apexchart>
        </v-card>
      </div>
      <div class="col-md-4">
        <v-card style="height: 168px">
          <v-card-title class="pb-0">
            <div class="">
              <p class="title_bi mb-0">Flujo de caja</p>
              <p class="caption">Ingresos - Egresos</p>
            </div>
          </v-card-title>

          <v-card-text>
            <div class="row">
              <div class="col p-12">
                <p class="text-center text-h5 font-weight-bold" :style="'color:' + getColor()">${{ new Intl.NumberFormat("es-ES").format(total_ingresos - total_egresos) }}</p>
              </div>
            </div>
          </v-card-text>
        </v-card>
        <v-card class="mt-4" style="height: 168px">
          <v-card-title class="pb-0">
            <div class="">
              <p class="title_bi mb-0">Ratio de cobertura</p>
              <p class="caption">Ingresos / Egresos</p>
            </div>
          </v-card-title>

          <v-card-text>
            <div class="row">
              <div class="col p-12">
                <p class="text-center text-h5 font-weight-bold" :style="'color:' + getColor()">
                  {{ total_egresos === 0 ? "-" : (total_ingresos / total_egresos).toFixed(3) }}
                </p>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </div>
    </div>
    <v-divider></v-divider>
    <p class="title_bi mb-0">Situacion Actual</p>
    <p class="caption mb-4">Análisis financiero de la situación actual de la empresa</p>

    <div class="row">
      <div class="col-md-6">
        <v-card style="height: 300px">
          <v-card-title class="container-title-box pt-3 pb-0">
            <div class="">
              <p class="title_bi mb-0">Cuentas a cobrar</p>
              <p class="caption text-slate-500">Comprobantes <b>vencidos</b> pendientes de cobro</p>
            </div>
          </v-card-title>

          <v-card-text>
            <div class="row mt-2">
              <div class="col-md-6 text-center d-flex flex-column justify-center align-items-center">
                <span class="text-sm text-slate-500 mb-1">Total vencido</span>
                <p class="text-center text-h6 font-weight-bold text-black">${{ new Intl.NumberFormat("es-ES").format(total_cuentas_por_cobrar) }}</p>
              </div>
              <div class="col-md-6 d-flex flex-column justify-center align-items-center">
                <apexchart height="200px" type="donut" ref="statPendienteCobro" :options="optionsPendientesCobro" :series="seriesPendienteDeCobro"></apexchart>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </div>
      <div class="col-md-6">
        <v-card style="height: 300px">
          <v-card-title class="container-title-box pt-3 pb-0">
            <div class="">
              <p class="title_bi mb-0">Cuentas a pagar</p>
              <p class="caption text-slate-500">Comprobantes <b>vencidos</b> pendientes de pago</p>
            </div>
          </v-card-title>

          <v-card-text>
            <div class="row mt-2">
              <div class="col-md-6 text-center d-flex flex-column justify-center align-items-center">
                <span class="text-sm text-slate-500 mb-1">Total vencido</span>
                <p class="text-center text-h6 font-weight-bold text-black">${{ new Intl.NumberFormat("es-ES").format(total_cuentas_por_pagar) }}</p>
              </div>
              <div class="col-md-6 d-flex flex-column justify-center align-items-center">
                <apexchart height="200px" type="donut" ref="statPendientePago" :options="optionsPendientesPago" :series="seriesPendienteDePago"></apexchart>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <v-card style="min-height: 192px">
          <v-card-title class="container-title-box pt-3 pb-0">
            <div class="">
              <p class="title_bi mb-0">Liquidez</p>
              <p class="caption text-slate-500">Saldo de las distintas cuentas</p>
            </div>
          </v-card-title>

          <v-card-text style="min-height: 263px">
            <div class="row mt-2">
              <div class="col p-12 mt-5">
                <div v-for="item in liquidez" :key="item.tipo" class="status-card mb-2">
                  <span class="status-name">{{ item.tipo }}</span>
                  <span class="status-amount" :style="item.amount < 0 ? 'color:#E53935' : ''">${{ new Intl.NumberFormat("es-ES").format(item.amount) }}</span>
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </div>
      <div class="col-md-8">
        <v-card style="min-height: 192px">
          <v-card-title class="container-title-box pt-3 pb-0">
            <div class="">
              <p class="title_bi mb-0">Cheques - Proyeccion de cobros y pagos</p>
              <p class="caption text-slate-500">Resumen de cheques a cobrar y a pagar en los proximos 30 días</p>
            </div>
          </v-card-title>

          <v-card-text>
            <div class="row mt-2">
              <div class="col p-12">
                <apexchart type="area" height="220" ref="statCheques" :options="optionsCheques" :series="seriesCheques"></apexchart>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import { metricsService } from "@/libs/ws/metricsService.js";
import { generalService } from "@/libs/ws/generalService";
import Constant from "@/constants/sections";
export default {
  components: {},
  data() {
    return {
      loading: false,
      menu: false,
      service: metricsService,
      from_date: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().slice(0, 10),
      to_date: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().slice(0, 10),
      currency: { id: "ARS", name: "ARS" },
      months: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
      total_ingresos: 0,
      total_egresos: 0,
      total_cuentas_por_cobrar: 0,
      total_cuentas_por_pagar: 0,
      monedas: metricsService.getMonedas(),
      liquidez: [],
      seriesIngresosEgresos: [
        {
          name: "Ingreso",
          data: [],
        },
        {
          name: "Egresos",
          data: [],
        },
      ],
      seriesPendienteDePago: [],
      seriesPendienteDeCobro: [],
      seriesCheques: [],
      chartOptionsIngresosEgresos: {
        chart: {
          type: "area",
          height: 180,
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "straight",
          width: 2,
        },
        colors: ["#388E3C", "#E53935"],
        labels: [],
        legend: {
          horizontalAlign: "left",
        },
        yaxis: {
          labels: {
            formatter: function (val, index) {
              return new Intl.NumberFormat("es-ES").format(val);
            },
          },
        },
        xaxis: {
          categories: [],
          tickAmount: 3,
        },
      },
      optionsPendientesCobro: {
        chart: {
          type: "donut",
        },
        labels: [],
        legend: {
          show: false,
        },
        dataLabels: {
          enabled: true,
          style: {
            fontSize: "12px",
            colors: ["#666"], // esto pone las etiquetas en negro
          },
          dropShadow: {
            enabled: false,
          },
          formatter: function (val) {
            return val.toFixed(1) + "%";
          },
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: false,
              },
            },
            dataLabels: {
              offset: 40, // aleja los porcentajes del centro del donut
            },
          },
        },
        yaxis: {
          labels: {
            formatter: function (val, index) {
              return new Intl.NumberFormat("es-ES").format(val);
            },
          },
        },
        colors: [],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },
      optionsPendientesPago: {
        chart: {
          type: "donut",
        },
        labels: [],
        legend: {
          show: false,
        },
        dataLabels: {
          enabled: true,
          style: {
            fontSize: "12px",
            colors: ["#666"], // esto pone las etiquetas en negro
          },
          dropShadow: {
            enabled: false,
          },
          formatter: function (val) {
            return val.toFixed(1) + "%";
          },
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: false,
              },
            },
            dataLabels: {
              offset: 40, // aleja los porcentajes del centro del donut
            },
          },
        },
        yaxis: {
          labels: {
            formatter: function (val, index) {
              return new Intl.NumberFormat("es-ES").format(val);
            },
          },
        },
        colors: [],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },
      optionsCheques: {
        chart: {
          type: "area",
          height: 180,
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "straight",
          width: 2,
        },
        colors: ["#388E3C", "#E53935"],
        labels: [],
        legend: {
          horizontalAlign: "left",
        },
        yaxis: {
          labels: {
            formatter: function (val, index) {
              return new Intl.NumberFormat("es-ES").format(val);
            },
          },
        },
        xaxis: {
          categories: [],
        },
      },
    };
  },
  mounted() {
    this.getIngresosVsEgresos();
    this.getPendienteDePagoVencido();
    this.getPendienteDeCobroVencido();
    this.getCheques();
    this.getLiquidez();
  },
  watch: {},
  methods: {
    getLiquidez() {
      this.loading = true;

      metricsService
        .getLiquidez()
        .then((response) => {
          if (response.status === false) {
            return;
          }

          this.liquidez = response.result;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getCheques() {
      this.loading = true;

      metricsService
        .getCheques()
        .then((response) => {
          if (response.status === false) {
            return;
          }
          var arr_cheques_a_cobrar = [];
          var arr_cheques_a_pagar = [];
          var xaxis = [];
          var dataMap = {};

          // Create a map to ensure all dates are accounted for
          response.result.forEach((element) => {
            const date = this.getDateFormat(element.payment_date);
            if (!dataMap[date]) {
              dataMap[date] = { a_cobrar: 0, a_pagar: 0 };
            }
            if (element.tipo === "a_pagar") {
              dataMap[date].a_pagar += parseFloat(element.amount);
            } else {
              dataMap[date].a_cobrar += parseFloat(element.amount);
            }
          });

          // Populate arrays based on the map
          Object.keys(dataMap)
            .sort((a, b) => new Date(a) - new Date(b))
            .forEach((date) => {
              xaxis.push(date);
              arr_cheques_a_cobrar.push(dataMap[date].a_cobrar);
              arr_cheques_a_pagar.push(dataMap[date].a_pagar);
            });

          this.seriesCheques = [
            {
              name: "Cheque a cobrar",
              data: arr_cheques_a_cobrar,
            },
            {
              name: "Cheque a pagar",
              data: arr_cheques_a_pagar,
            },
          ];

          this.$refs.statCheques.updateOptions({
            xaxis: {
              categories: xaxis,
              tickAmount: 30, // Dynamically adjust tickAmount to show up to 10 ticks
            },
          });
          this.$refs.statCheques.updateSeries(this.seriesCheques, false, true);

          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getPendienteDePagoVencido() {
      this.loading = true;

      metricsService
        .getPendienteDePago()
        .then((response) => {
          if (response.status === false) {
            return;
          }
          var arr = [];
          var labels = [];

          response.result.forEach((element) => {
            this.total_cuentas_por_pagar = this.total_cuentas_por_pagar + parseFloat(element.total_adeudado);
            arr.push(parseFloat(element.total_adeudado));
            labels.push(element.name);
          });

          this.total_cuentas_por_pagar = this.total_cuentas_por_pagar.toFixed(2);
          this.seriesPendienteDePago = [
            {
              name: "Cuentas por pagar",
              data: arr,
            },
          ];

          this.optionsPendientesPago = {
            labels: labels,
          };
          this.seriesPendienteDePago = arr;
          this.$refs.statPendientePago.updateSeries(this.seriesPendienteDePago, false, true);
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getPendienteDeCobroVencido() {
      this.loading = true;

      metricsService
        .getPendienteDeCobro()
        .then((response) => {
          if (response.status === false) {
            return;
          }
          var arr = [];
          var labels = [];

          response.result.forEach((element) => {
            this.total_cuentas_por_cobrar = this.total_cuentas_por_cobrar + parseFloat(element.total_adeudado);
            arr.push(parseFloat(element.total_adeudado));
            labels.push(element.name);
          });

          this.total_cuentas_por_cobrar = this.total_cuentas_por_cobrar.toFixed(2);
          this.seriesPendienteDeCobro = [
            {
              name: "Cuentas por cobrar",
              data: arr,
            },
          ];

          this.optionsPendientesCobro = {
            labels: labels,
          };
          this.seriesPendienteDeCobro = arr;
          this.$refs.statPendienteCobro.updateSeries(this.seriesPendienteDeCobro, false, true);
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getColor() {
      if (this.total_egresos === 0) {
        return "";
      }
      if (this.total_ingresos / this.total_egresos < 1) {
        return "#E53935";
      } else {
        return "#388E3C";
      }
    },
    getDateFormat(date) {
      var date_aux = date.split("-");
      var d = new Date(date);
      return date_aux[2] + " " + this.months[d.getMonth()];
    },
    getIngresosVsEgresos() {
      this.loading = true;

      this.total_ingresos = 0;
      this.total_egresos = 0;

      metricsService
        .getIngresosVsEgresos({
          from_date: this.from_date,
          to_date: this.to_date,
          currency: this.currency.id,
        })
        .then((response) => {
          if (response.status === false) {
            return;
          }
          var arrIngresos = [];
          var arrEgresos = [];
          var xaxis = [];
          var dataMap = {};

          // Create a map to ensure all dates are accounted for
          response.result.forEach((element) => {
            const date = this.getDateFormat(element.fecha);
            if (!dataMap[date]) {
              dataMap[date] = { ingreso: 0, egreso: 0 };
            }
            if (element.tipo === "ingreso") {
              dataMap[date].ingreso += parseFloat(element.importe);
            } else {
              dataMap[date].egreso += parseFloat(element.importe);
            }
          });

          // Populate arrays based on the map
          Object.keys(dataMap)
            .sort((a, b) => new Date(a) - new Date(b))
            .forEach((date) => {
              xaxis.push(date);
              arrIngresos.push(dataMap[date].ingreso);
              arrEgresos.push(dataMap[date].egreso);
            });

          this.total_ingresos = arrIngresos.reduce((a, b) => a + b, 0).toFixed(2);
          this.total_egresos = arrEgresos.reduce((a, b) => a + b, 0).toFixed(2);

          this.seriesIngresosEgresos[0].data = arrIngresos;
          this.seriesIngresosEgresos[1].data = arrEgresos;
          this.$refs.statIngresosEgresos.updateSeries(this.seriesIngresosEgresos, false, true);
          this.$refs.statIngresosEgresos.updateOptions({
            xaxis: {
              categories: xaxis,
              tickAmount: 10,
            },
          });
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
